import { connect } from 'react-redux';

import {
  getDashboards,
  getMyPermissions,
  getSelectedDashboard,
  getUnitsExecutionState,
  getIsUpdatingDashboard,
} from '../../../reducers/analyticsApp';
import {
  deleteDashboard,
  selectDashboard,
  updateMode,
  createMode,
  resetDashboardCompose,
  copyMode,
} from '../../../actions/dashboards/dashboards';
import SelectedDashboard from '../../../components/dashboards/cards/SelectedDashboard';
import { staticPermissions } from '../../../constants/authorization';

const mapStateToProps = (state) => {
  const permissions = getMyPermissions(state);

  return {
    dashboards: getDashboards(state).sort((a, b) => a.name.localeCompare(b.name)),
    selectedDashboard: getSelectedDashboard(state),
    executionState: getUnitsExecutionState(state),
    isDashboardManagePermission: permissions.has(staticPermissions.DASHBOARDS_MANAGE),
    isUpdating: getIsUpdatingDashboard(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  setSelectedDashboard: (id) => dispatch(selectDashboard(id)),
  onDelete: (id) => dispatch(deleteDashboard(id)),
  onCreate: () => {
    dispatch(resetDashboardCompose());
    dispatch(createMode());
  },
  onUpdate: (dashboard) => {
    dispatch(updateMode(structuredClone(dashboard)));
  },
  onCopy: (dashboard) => {
    dispatch(copyMode(structuredClone(dashboard)));
  },
});

const mergeProps = (mapStateToPropsParam, mapDispatchToPropsParam, ownProps) => {
  const { selectedDashboard, dashboards } = mapStateToPropsParam;
  const { onUpdate, onCopy, onDelete } = mapDispatchToPropsParam;
  return {
    ...ownProps,
    ...mapStateToPropsParam,
    ...mapDispatchToPropsParam,
    onDelete: () => onDelete(selectedDashboard),
    onUpdate: () => onUpdate(dashboards.find((d) => d.id === selectedDashboard)),
    onCopy: () => onCopy(dashboards.find((d) => d.id === selectedDashboard)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SelectedDashboard);
